var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.timeline},_vm._l((_vm.stories.length),function(item,i){return _c('div',{key:i,class:_vm.$style.item},[_c('div',{class:_vm.$style.progress,style:(`width: ${_vm.progress(i)}%`)})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }